import * as React from "react";
import classes from "./AuditTrailSearchResult.module.css";
import Button from "@mui/material/Button";
import exportAsCsv from "utils/exportAsCsv";
import moment from "moment";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import SnackBar from "components/SnackBar/SnackBar";
import PrimeReactDataGrid from "components/PrimeReactDataGrid/PrimeReactDataGrid";
const AuditTrailSearchResults = (props) => {
  const [rows, setRows] = React.useState([]);
  const [gridPageSize, setGridPageSize] = React.useState(10);
  const [selectedRows, setSelectedRows] = React.useState([]);
  const [rowData, setRowData] = React.useState([]);
  const [snack, setSnack] = React.useState({
    open: false,
    message: "",
    severity: "",
  });

  const calculatePageSize = () => {
    const height = window.innerHeight;
    const width = window.innerWidth;
    if (height > 1200) return 100;
    if (height > 900) return 50;
    if (height > 600) return 25;
    return 10;
  };

  const snackReset = () => {
    setSnack({
      open: false,
      message: "",
      severity: "",
    });
  };

  const columns = [
    {
      field: "HRSystem",
      header: "HR System",
      width: 90,
      align: "center",
      headerAlign: "center",
      sortable: true,
      filter: true,
      filterPlaceholder: "Search by HR System",
    },
    {
      field: "OracleIdOrExtEmployeeId",
      header: "Oracle Id / Ext EmployeeID",
      width: 170,
      align: "center",
      headerAlign: "center",
      sortable: true,
      filter: true,
      filterPlaceholder: " Search by Oracle Id/Ext EmployeeID",
    },
    {
      field: "EmployeeName",
      align: "center",
      width: 150,
      header: "Employee Name",
      headerAlign: "center",
      sortable: true,
      filter: true,
      filterPlaceholder: "Search by Employee Name",
    },
    {
      field: "LogonId",
      header: "Logon ID",
      align: "center",
      width: 200,
      type: "number",
      headerAlign: "center",
      sortable: true,
      filter: true,
      filterPlaceholder: "Search by Logon ID",
    },
    {
      field: "SystemName",
      header: "System",
      sortable: true,
      width: 150,
      align: "center",
      headerAlign: "center",
      filter: true,
      filterPlaceholder: "Search by System",
    },
    {
      field: "SubSystemName",
      header: "Sub System",
      width: 150,
      sortable: true,
      align: "center",
      headerAlign: "center",
      filter: true,
      filterPlaceholder: "Search by Sub System",
    },
    {
      field: "Operation",
      header: "Operation",
      sortable: true,
      width: 200,
      align: "center",
      headerAlign: "center",
      filter: true,
      filterPlaceholder: "Search by Operation",
    },
    {
      field: "UpdateDateTime",
      header: "Updated Date / Time",
      sortable: true,
      width: 250,
      align: "center",
      headerAlign: "center",
      filter: true,
      filterPlaceholder: "Search by update Date/Time",
    },
    {
      field: "UpdatedBy",
      header: "Updated By",
      sortable: true,
      width: 200,
      align: "center",
      headerAlign: "center",
      filter: true,
      filterPlaceholder: "Search by Updated By",
    },
    {
      field: "IsBulk",
      header: "Bulk Edit",
      sortable: true,
      width: 200,
      align: "center",
      headerAlign: "center",
      filter: true,
      filterPlaceholder: "Search by Bulk Edit",
    },
  ];

  const filterProps = {
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    HRSystem: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    OracleIdOrExtEmployeeId: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    EmployeeName: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    LogonId: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    SystemName: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    SubSystemName: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    Operation: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
    },
    UpdateDateTime: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
    },
    UpdatedBy: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
    },
    IsBulk: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
    },
  };

  React.useEffect(() => {
    const data = props?.rows?.map((rowItem, index) => {
      return {
        id: index + 1,
        HRSystem: rowItem["HRSystem"],
        OracleIdOrExtEmployeeId: rowItem["OracleIdOrExtEmployeeId"],
        EmployeeName: rowItem["EmployeeName"],
        LogonId: rowItem["LogonId"],
        SystemName: rowItem["SystemName"],
        SubSystemName: rowItem["SubSystemName"],
        Operation: rowItem["Operation"],
        UpdateDateTime: rowItem["UpdateDateTime"]
          ? moment(rowItem["UpdateDateTime"]).format("YYYY-MM-DD")
          : "",
        UpdatedBy: rowItem["UpdatedBy"],
        IsBulk: rowItem["IsBulk"] ? "Yes" : "No",
      };
    });
    setRows(data);
    const updatePageSize = () => {
      setGridPageSize(calculatePageSize());
    };
    updatePageSize();
    window.addEventListener("resize", updatePageSize);
    setRowData(data);
  }, [props?.rows]);

  const onRowSelectChange = (event) => {
    try {
      if (event.checked) {
        setSelectedRows(rowData);
      } else if (event.originalEvent.target.checked === false) {
        setSelectedRows([]);
      } else {
        setSelectedRows(event.value);
      }
    } catch (error) {
      setSnack({
        open: true,
        message: "Error occurred while changing row selection.",
        severity: "error",
      });
    }
  };

  return (
    <>
      <div className={classes.searchResultContainer}>
        <div className={classes.exportContainer}>
          <Button
            sx={{
              textTransform: "none",
              color: "#2AA154",
              borderColor: "#2AA154",
              borderRadius: "8px",
              fontFamily: "urbanist",
            }}
            variant="outlined"
            startIcon={<FileUploadIcon />}
            onClick={() => exportAsCsv(rows, columns, "CPSearchEmployee")}
          >
            Export
          </Button>
        </div>
        <div className={classes.dataGridContainer}>
          <PrimeReactDataGrid
            columns={columns}
            removableSort
            resizableColumns
            showGridlines
            paginator
            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} record(s)"
            columnResizeMode="expand"
            value={rows}
            selectionMode="single"
            dragSelection
            metaKeySelection={false}
            rows={gridPageSize}
            onSelectionChange={onRowSelectChange}
            selection={selectedRows}
            rowsPerPageOptions={[5, 10, 25, 50, 100]}
            filterprops={filterProps}
            globalFilterFields={[
              "HRSystem",
              "OracleIdOrExtEmployeeId",
              "EmployeeName",
              "LogonId",
              "SystemName",
              "SubSystemName",
              "Operation",
              "UpdateDateTime",
              "UpdatedBy",
              "IsBulk",
            ]}
          />
        </div>
      </div>
      <SnackBar snack={snack} snackReset={snackReset}></SnackBar>;
    </>
  );
};
export default AuditTrailSearchResults;
